// Third Party Imports
import toast from "react-hot-toast";
import { AxiosResponse } from "axios";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";

// Local Imports
import instance from "../../store/axios";
import { LOADING, LOGIN } from "../../store/actions";
import { FormValues, LoginApiResponse } from "./types";
import { encryptPassword } from "src/utils/helper/functions";
class LoginService {
  private dispatch = useDispatch();
  private navigate = useNavigate();

  public async onSubmit(values: FormValues): Promise<void> {
    this.dispatch({ type: LOADING, payload: true });

    try {
      const response: AxiosResponse<{
        data: LoginApiResponse;
        message: string;
      }> = await instance.post(`/${process.env.REACT_APP_ENDPOINT_VERSION}/auth/login`, {
        email: values.email,
        password: encryptPassword(values.password),
      });
      if (response?.data?.data?.permissions.includes("dummy_permission")) {
        toast.error("Sorry you are not authorized to access this platform");
      } else {
        this.dispatch({
          type: LOGIN,
          payload: {
            user: response?.data?.data,
          },
        });
        toast.success("Welcome " + response.data?.data?.name);
        localStorage.setItem(
          "selectedBranches",
          JSON.stringify(response.data?.data?.branches)
        );

        if (localStorage.getItem("star_prev_url")) {
          this.navigate(localStorage.getItem("star_prev_url"));
        } else {
          if (response?.data?.data?.permissions.includes("view_customers")) {
            this.navigate("/home/customers-list");
          } else {
            if (
              response?.data?.data?.permissions[0] === "request_withdrawal" &&
              response?.data?.data?.withdrawGroup
            ) {
              this.navigate("/withdrawal");
            } else if (
              response?.data?.data?.permissions[0] === "request_account_closure"
            ) {
              this.navigate("/home/closure-requests");
            } else if (
              response?.data?.data?.permissions[0] === "request_portfolios"
            ) {
              this.navigate("/portfolio");
            } else if (
              response?.data?.data?.permissions[0] === "request_deposit"
            ) {
              this.navigate("/deposit");
            } else if (
              response?.data?.data?.permissions[0] === "request_redemption"
            ) {
              this.navigate("/redemptions");
            } else if (
              response?.data?.data?.permissions[0] === "request_subscription"
            ) {
              this.navigate("/subscription");
            } else {
              this.navigate("/home");
            }
          }
        }
        // this.navigate('/home');
      }
    } catch (error: any) {
      toast.error(error?.response?.data?.message || "An error occurred");
    } finally {
      this.dispatch({ type: LOADING, payload: false });
    }
  }

  public async logout(): Promise<boolean> {
    this.dispatch({ type: LOADING, payload: true });

    try {
      await instance.post(`/${process.env.REACT_APP_ENDPOINT_VERSION}/auth/revoke`);
      return true;
    } catch (error: any) {
      if (error?.response?.status !== 401) {
        toast.error(error?.response?.data?.message || "An error occurred");
      }
    } finally {
      this.dispatch({ type: LOADING, payload: false });
    }
  }

  public async setNewPassword(values: any) {
    this.dispatch({ type: LOADING, payload: true });

    try {
      await instance.post(`/${process.env.REACT_APP_ENDPOINT_VERSION}/auth/reset-password`, {
        password: encryptPassword(values.password),
        resetPasswordToken: values.token,
      });
      toast.success("Password updated successfully");
      this.navigate("/login");
    } catch (error: any) {
      if (error?.response?.status !== 401) {
        toast.error(error?.response?.data?.message || "An error occurred");
      }
    } finally {
      this.dispatch({ type: LOADING, payload: false });
    }
  }
}

export default LoginService;
